import { type TFunction } from 'i18next';
import moment from 'moment';

export const computeTotalTime = (t: TFunction, startTime: string, endTime: string, useSymbols = false) => {
    if (!startTime || !endTime) {
        return;
    }

    const date1 = moment(startTime);
    const date2 = moment(endTime);

    const totalTime = moment.duration(date2.diff(date1, 'milliseconds'));

    const days = totalTime.days();
    const hours = totalTime.hours();
    const minutes = totalTime.minutes();

    const dayString = days > 0 ? useSymbols ? `${days}D ` : `${days} ${ days === 1 ? t('day') : t('days') } ` : '';
    const hourString = hours > 0 ? useSymbols ? `${hours}H ` : `${hours} ${hours === 1 ? t('hour') : t('hours')} ` : '';
    const minuteString = minutes > 0 ? useSymbols ? `${minutes}M` : `${minutes} ${minutes === 1 ? t('minute') : t('minutes')}` : '';

    return `${dayString}${hourString}${minuteString}`;
};
